const CircleArrowUpRight02Icon = /*#__PURE__*/ [
  ["path", { d: "M21.9999 12C21.9999 17.5228 17.5227 22 11.9999 22C6.47703 22 1.99988 17.5228 1.99988 12C1.99988 6.47715 6.47703 2 11.9999 2C17.5227 2 21.9999 6.47715 21.9999 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9999 9L7.99988 16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.99988 8.11274C9.99988 8.11274 14.8286 7.70569 15.5614 8.43847C16.2942 9.17125 15.8871 14 15.8871 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { CircleArrowUpRight02Icon as default };
//# sourceMappingURL=CircleArrowUpRight02Icon.js.map
